import { Stack, FormTextField, HookForm, FormContentIsland, Button } from '@razz-team/ui-web';
import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';
import { useForm } from 'react-hook-form';
import { useFormError } from '../../../../hooks/useFormError';
import { useUpdateProfileInfoMutation } from '../../../../api/businesses';

type KybNameFormValues = {
  name: string;
};

export function BusinessNameStep() {
  const { t } = useTranslation();
  const form = useForm<KybNameFormValues>();

  const mutation = useUpdateProfileInfoMutation();
  const handleSubmit = useCallback(
    (values: KybNameFormValues) => {
      mutation.mutate(values);
    },
    [mutation],
  );

  useFormError(form, 'name', mutation.error);

  return (
    <Stack
      spacing={4}
      padding={4}
      width="100%"
      component={HookForm}
      form={form}
      onSubmit={handleSubmit}
    >
      <FormContentIsland>
        <FormTextField
          name="name"
          label={t('Company name')}
          required
          minLength={3}
          autoFocus
          autoComplete="off"
          fullWidth
        />
      </FormContentIsland>
      <Button
        type="submit"
        loading={mutation.isPending}
        disabled={!form.formState.isDirty}
        size="large"
        fullWidth
      >
        {t('Continue')}
      </Button>
    </Stack>
  );
}
